import AdvancedController from "./advanced-controller"
import gsap from 'gsap';
import { docCookies } from "./doc-cookies";

const Config = {
  ANIMATION_DURATION: 0.75,
}

export default class PopupController extends AdvancedController {
  static values = {
    cookieDuration: Number,
    cookieName: String,
    openAfter: Number,
  }

  static targets = []

  connect() {
    if (docCookies.getItem(this.cookieNameValue) !== "seen") {
      this.pollCheckForBorlabsBeforeOpening();
    }
  }

  pollCheckForBorlabsBeforeOpening() {
    // schedule checks each second
    const intervalId = setInterval(() => {
      this.checkIfBorlabsIsOpen(intervalId)
    }, 1000);
  }

  checkIfBorlabsIsOpen(intervalId) {
    if (!document.body.classList.contains("borlabs-position-fix")) {
      clearInterval(intervalId);
      this.scheduleOpening();
    }
  }

  scheduleOpening() {
    setTimeout(() => {
      this.open();
    }, this.openAfterValue * 1000)
  }

  open() {
    gsap.to(this.element, { opacity: 1, display: 'flex', duration: Config.ANIMATION_DURATION })
  }

  close(e) {
    e.preventDefault();

    const onComplete = () => {
      this.element.style.display = 'none';
    }
    this.setCookie();
    gsap.to(this.element, { opacity: 0, duration: Config.ANIMATION_DURATION, onComplete })

    if (e.target.hasAttribute('href') && e.target.getAttribute('href') != "#") {
      location.href = e.target.getAttribute('href');
    }
  }

  setCookie() {
    const expiresAt = new Date(new Date().getTime() + this.cookieDurationValue * 24 * 60 * 60 * 1000)
    docCookies.setItem(this.cookieNameValue, "seen", expiresAt, "/");
  }

}